export default [
  {
    path: "/login",
    redirect: "/signin",
  },
  {
    path: "/signin",
    component: () => import("@/views/signin/SignInView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
      hideNav: true,
    },
  },
  {
    path: "/signin/forgot",
    component: () => import("@/views/signin/ForgotView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
    },
  },
  {
    path: "/signin/forgot/success",
    component: () => import("@/views/signin/ForgotSuccessView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
    },
  },
  {
    path: "/signin/new-password",
    component: () => import("@/views/signin/NewPasswordView.vue"),
    meta: {
      authentication: { required: false, redirectAuthenticated: "/" },
      hideNav: true,
    },
  },
];
